import diff from "refractor/diff";
export default diff;